
import { Component, Vue } from "vue-property-decorator";
import { SMUser } from "@/store";

const CANDIDATES_ROUTE = "EmployerServicesCandidates";

import WidgetCandidateAssessment from "@/modules/Compliance/Widgets/WidgetCandidateAssessment.vue";
import WidgetSkilledWorkerVisa from "@/modules/Compliance/Widgets/WidgetSkilledWorkerVisa.vue";
import WidgetHealthCareVisa from "@/modules/Compliance/Widgets/WidgetHealthCareVisa.vue";
import WidgetILR from "@/modules/Compliance/Widgets/WidgetILR.vue";

import { ICONS } from "@/constants/icons";

import { CANDIDATE_ASSESSMENT_SERVICE, START_SERVICE_EVENT } from "@/constants/services";

const INVITE_CANDIDATE_ROUTE = "InviteCandidate";

const ICON_CLOSE = "close-outline";

@Component({
  components: {
    HelloMessage: () =>
      import("@/pages/Layout/views/Employer/views/Compliance/components/HelloMessage.vue"),
    WidgetCandidateAssessment,
    WidgetSkilledWorkerVisa,
    WidgetHealthCareVisa,
    WidgetILR,
    EmployerServicesTables: () =>
      import("@/modules/Services/Components/Table/EmployerServicesTables.vue"),
    WidgetGetSponsorLicence: () =>
      import("@/modules/Compliance/Widgets/WidgetGetSponsorLicence.vue"),
    IconButtonBlock: () =>
      import("@/modules/Compliance/Blocks/IconButtonBlock/IconButtonBlock.vue"),
    WidgetGetSponsorLicenceDialog: () =>
      import(
        "@/modules/Compliance/Widgets/WidgetGetSponsorLicence/WidgetGetSponsorLicenceDialog.vue"
      ),
    ProcessProgress: () => import("@/components/ProcessProgress/ProcessProgress.vue"),
  },
})
export default class Services extends Vue {
  icons = ICONS;

  showUserHelloMessage = false;

  iconClose = ICON_CLOSE;

  dialogs = {
    widgetSubmit: false,
  };

  showServicesProcess = true;

  get isServicesProcessHidden() {
    return !!window.localStorage.getItem("hide-services-process") || !this.showServicesProcess;
  }

  hideServicesProcess() {
    this.showServicesProcess = false;

    window.localStorage.setItem("hide-services-process", "true");
  }

  hideHelloMessage() {
    localStorage.removeItem("show_hello_msg_services_for_first_time_signed");

    this.showUserHelloMessage = false;
  }

  get isSponsorConfirmed() {
    return SMUser.isSponsorConfirmation ?? false;
  }

  get ifSponsor() {
    // TODO: Really search "some" by target.name?
    // return (
    //   SMUser.user?.if_sponsor || this.cases.some((val) => val.name === SPONSOR_LICENCE_SERVICE_TYPE)
    // );

    return SMUser.user?.if_sponsor;
  }

  get isSLStarted() {
    return SMUser.user?.is_sl_started;
  }

  get hideSLWidget() {
    return this.isSLStarted || this.ifSponsor;
  }

  openSuccessPopup() {
    this.dialogs.widgetSubmit = true;
  }

  closeSuccessPopup() {
    this.dialogs.widgetSubmit = false;
  }

  mounted() {
    const firstTimeSignedUserId = localStorage.getItem(
      "show_hello_msg_services_for_first_time_signed"
    );

    const userID = String(SMUser.user?.ID);

    if (firstTimeSignedUserId === userID) this.showUserHelloMessage = true;
  }

  showSponsorLicencePopup = false;

  openSponsorLicencePopup() {
    this.showSponsorLicencePopup = true;
  }

  closeSponsorLicencePopup() {
    this.showSponsorLicencePopup = false;
  }

  async startSW() {
    await this.$router.push({
      name: CANDIDATES_ROUTE,
    });
  }

  inviteCandidate() {
    const query = {
      event: START_SERVICE_EVENT,
      service: CANDIDATE_ASSESSMENT_SERVICE,
    };

    this.$router.push({
      name: INVITE_CANDIDATE_ROUTE,
      query,
    });
  }
}
